"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledModalArea = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styledSystem = require("styled-system");

var _emotionTheming = require("emotion-theming");

var _flex = require("../flex");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var verticalPadding = function verticalPadding(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return R.prop(variant, {
    header: theme.spacing[3],
    body: theme.spacing[4],
    footer: theme.spacing[3]
  });
};

var ModalAreaContainer = (0, _emotionTheming.withTheme)(function (_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      modalYPadding = _ref2.modalYPadding,
      theme = _ref2.theme,
      rest = _objectWithoutProperties(_ref2, ["className", "children", "modalYPadding", "theme"]);

  return (0, _core.jsx)(_flex.Box, _extends({
    className: className,
    px: theme.spacing[4],
    py: modalYPadding,
    theme: theme
  }, rest), children);
});
var StyledModalArea = (
/*#__PURE__*/
0, _styledBase.default)(ModalAreaContainer, {
  target: "e1of6tv00"
})("border-bottom:1px solid ", (0, _styledSystem.themeGet)('colors.neutral.4'), ";&:last-child{border-bottom:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RhbC9tb2RhbC1hcmVhLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCeUQiLCJmaWxlIjoiLi4vLi4vc3JjL21vZGFsL21vZGFsLWFyZWEuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0ICogYXMgUiBmcm9tICdyYW1kYSc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgY29tcG9zZSwgZGVmYXVsdFByb3BzLCBzZXRQcm9wVHlwZXMsIHNldERpc3BsYXlOYW1lLCB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJ2Vtb3Rpb24tdGhlbWluZyc7XG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuLi9mbGV4JztcblxuY29uc3QgdmVydGljYWxQYWRkaW5nID0gKHsgdGhlbWUsIHZhcmlhbnQgfSkgPT4gUi5wcm9wKHZhcmlhbnQsXG4gICh7XG4gICAgaGVhZGVyOiB0aGVtZS5zcGFjaW5nWzNdLFxuICAgIGJvZHk6IHRoZW1lLnNwYWNpbmdbNF0sXG4gICAgZm9vdGVyOiB0aGVtZS5zcGFjaW5nWzNdXG4gIH0pXG4pO1xuXG5jb25zdCBNb2RhbEFyZWFDb250YWluZXIgPSB3aXRoVGhlbWUoKHsgY2xhc3NOYW1lLCBjaGlsZHJlbiwgbW9kYWxZUGFkZGluZywgdGhlbWUsIC4uLnJlc3QgfSkgPT4gKFxuICA8Qm94IGNsYXNzTmFtZT17Y2xhc3NOYW1lfSBweD17dGhlbWUuc3BhY2luZ1s0XX0gcHk9e21vZGFsWVBhZGRpbmd9IHRoZW1lPXt0aGVtZX0gey4uLnJlc3R9PlxuICAgIHtjaGlsZHJlbn1cbiAgPC9Cb3g+XG4pKTtcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1vZGFsQXJlYSA9IHN0eWxlZChNb2RhbEFyZWFDb250YWluZXIpYFxuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgJHt0aGVtZUdldCgnY29sb3JzLm5ldXRyYWwuNCcpfTtcbiAgJjpsYXN0LWNoaWxkIHtcbiAgICBib3JkZXItYm90dG9tOiBub25lO1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjb21wb3NlKFxuICBkZWZhdWx0UHJvcHMoe1xuICAgIHZhcmlhbnQ6ICdib2R5J1xuICB9KSxcbiAgc2V0UHJvcFR5cGVzKHtcbiAgICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gICAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLFxuICAgIHZhcmlhbnQ6IFByb3BUeXBlcy5vbmVPZihbJ2hlYWRlcicsICdib2R5JywgJ2Zvb3RlciddKSxcbiAgfSksXG4gIHdpdGhUaGVtZSxcbiAgd2l0aFByb3BzKHByb3BzID0+ICh7XG4gICAgbW9kYWxZUGFkZGluZzogdmVydGljYWxQYWRkaW5nKHByb3BzKVxuICB9KSksXG4gIHNldERpc3BsYXlOYW1lKCdNb2RhbEFyZWEnKVxuKShTdHlsZWRNb2RhbEFyZWEpO1xuIl19 */"));
exports.StyledModalArea = StyledModalArea;

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  variant: 'body'
}), (0, _recompose.setPropTypes)({
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  variant: _propTypes.default.oneOf(['header', 'body', 'footer'])
}), _emotionTheming.withTheme, (0, _recompose.withProps)(function (props) {
  return {
    modalYPadding: verticalPadding(props)
  };
}), (0, _recompose.setDisplayName)('ModalArea'))(StyledModalArea);

exports.default = _default;